import Vue from 'vue'

import '../styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QUploader,
  QCheckbox,
  QSeparator,
  QInput,
  QSelect,
  QFooter,
  QPageScroller,
  QScrollArea,
  QTable,
  QTh,
  QTr,
  QTd,
  QTooltip,
  QForm,
  QLinearProgress,
  QInnerLoading,
  QSpinnerGears,
  QBadge,
  QDialog,
  ClosePopup,
  Loading,
  QSpace,
  Notify,
  QBar,
  QChip,
  QVirtualScroll,
  QRadio,
  QImg
} from 'quasar'

Vue.use(Quasar, {
  config: {
    supportIE: true
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QUploader,
    QCheckbox,
    QSeparator,
    QInput,
    QSelect,
    QFooter,
    QPageScroller,
    QScrollArea,
    QTable,
    QTh,
    QTr,
    QTd,
    QTooltip,
    QForm,
    QLinearProgress,
    QInnerLoading,
    QSpinnerGears,
    QBadge,
    QDialog,
    QSpace,
    QBar,
    QChip,
    QVirtualScroll,
    QRadio,
    QImg
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Loading,
    Notify
  },
  extras: [
    'fontawesome-v5',
    'roboto-font',
    'material-icons',
    'ionicons-v4'
  ],
  iconSet: iconSet
})
